/*
 * Copyright (c) 2023-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {PureComponent} from 'react';
import {IoTrashOutline} from "react-icons/io5";
import DisplayIcon from "../Icons/DisplayIcon.jsx";
import ButtonSkelet from "../BasicInputs/Buttons/ButtonSkelet.jsx";
import IconWithShortcut from "../Shortcuts/IconWithShortcut.jsx";

class DialogButton extends PureComponent {

    onKeyDown(event, button) {
        if (event.key === "Enter") {
            if (button.onClick !== undefined) {
                button.onClick()
            }
        }
    }

    render() {
        let {button = [], className} = this.props

        if (button.length === 0) {
            return (<div></div>)
        }

        return (
            <div
                className={`flex-shrink-0 px-4  py-4 flex bg-gray-50  gap-3 rounded-b-lg ${className ?? " "}`}>
                {button.map((button) => {
                    button.isActive ??= true
                    switch (button.type) {
                        case "primary":
                            return (<ButtonSkelet
                                onClick={async () => {
                                    if (button.onClick !== undefined) {
                                        await button.onClick()
                                    }
                                }}
                                onKeyDown={(event) => this.onKeyDown(event, button)}
                                className={` inline-flex justify-center py-2 px-6 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none select-none focus-visible:ring focus-visible:ring-blue-300 ${!button.isActive && ("!bg-indigo-300")}`}>
                                {button.text}
                            </ButtonSkelet>)
                        case "abort":
                            return (<ButtonSkelet
                                onClick={async () => {
                                    if (button.onClick !== undefined) {
                                        await button.onClick()
                                    }
                                }}
                                onKeyDown={(event) => this.onKeyDown(event, button)}
                                className={`inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none select-none focus-visible:ring focus-visible:ring-blue-300 ${!button.isActive && ("!bg-gray-200")}`}
                            >
                                <IconWithShortcut shortcuts={["esc"]}
                                                  iconName={"IoClose"}
                                                  className="-ml-1 mr-2 h-5 w-5 text-red-500"/>
                                <span>{button.text}</span>
                            </ButtonSkelet>)
                        case "auto":
                            let iconName = ""
                            let iconColor = ""

                            let text = button.text.toString().toLowerCase()
                            if (text === "ja" || text.includes("übernehmen")) {
                                iconName = "Check"
                                iconColor = "text-green-500"
                            } else if (text === "nein" || text.includes("abbrechen") || text.includes("verwerfen")) {
                                iconName = "IoCloseOutline"
                                iconColor = "text-red-500"
                            } else if (text.includes("speichern") || text.includes("save")) {
                                iconName = "IoSave"
                                iconColor = "text-blue-400"
                            } else if (text.includes("löschen") || text.includes("delete")) {
                                iconName = "IoTrashOutline"
                                iconColor = "text-red-500"
                            }


                            return (<ButtonSkelet
                                onClick={async () => {
                                    if (button.onClick !== undefined) {
                                        await button.onClick()
                                    }
                                }}
                                onKeyDown={(event) => this.onKeyDown(event, button)}
                                className={`inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none select-none focus-visible:ring focus-visible:ring-blue-300 ${!button.isActive && ("!bg-gray-200")}`}
                            >
                                {iconName !== "" && (<>
                                    <DisplayIcon
                                        iconName={iconName}
                                        className={`-ml-1 mr-2 h-5 w-5 ${iconColor}`}
                                        aria-hidden="true"/>
                                </>)}

                                <span>{button.text}</span>
                            </ButtonSkelet>)
                        case "save":
                            return (<ButtonSkelet
                                onClick={async () => {
                                    if (button.onClick !== undefined) {
                                        await button.onClick()
                                    }
                                }}
                                iconName={"IoSave"}
                                text={"button.text"}
                                className={`inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-500 hover:bg-blue-600 focus:outline-none select-none focus-visible:ring focus-visible:ring-blue-300 ${!button.isActive && ("!bg-blue-300")}`}
                            >
                                {(isLoading) => (<>
                                    {isLoading ? (<DisplayIcon iconName={"Spinner"}
                                                               className="-ml-1 mr-2 h-5 w-5 text-white animate-spin shrink-0 "/>) : (
                                        <IconWithShortcut shortcuts={["s"]}
                                                          iconName={"IoSave"}
                                                          className={"-ml-1 mr-2 h-5 w-5 text-white  shrink-0"}/>
                                    )}

                                    {button.text}
                                </>)}
                            </ButtonSkelet>)
                        case "delete":
                            return (<ButtonSkelet
                                onClick={async () => {
                                    if (button.onClick !== undefined) {
                                        await button.onClick()
                                    }
                                }}
                                onKeyDown={(event) => this.onKeyDown(event, button)}
                                className={`inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 hover:bg-red-100 focus:outline-none bg-red-50 select-none focus-visible:ring focus-visible:ring-blue-300 ${!button.isActive && ("!bg-gray-200")}`}
                            >
                                <IoTrashOutline
                                    className="-ml-1 mr-2 h-5 w-5 text-red-500"
                                    aria-hidden="true"/>
                                <span>{button.text}</span>
                            </ButtonSkelet>)
                        case "colored":
                            return (<ButtonSkelet
                                style={{
                                    backgroundColor: button.backgroundColor,
                                    color: button.color
                                }}
                                onClick={async () => {
                                    if (button.onClick !== undefined) {
                                        await button.onClick()
                                    }
                                }}
                                onKeyDown={(event) => this.onKeyDown(event, button)}
                                className="inline-flex justify-center bg-white py-2 px-5 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none select-none focus-visible:ring focus-visible:ring-blue-300">
                                {button.iconName !== undefined &&
                                    <DisplayIcon iconName={button.iconName} className="-ml-1 mr-2 h-5 w-5"/>}

                                {button.text}
                            </ButtonSkelet>)
                        case "secondary":
                        default:
                            return (<ButtonSkelet
                                onClick={async () => {
                                    if (button.onClick !== undefined) {
                                        await button.onClick()
                                    }
                                }}
                                onKeyDown={(event) => this.onKeyDown(event, button)}
                                className="bg-white py-2 px-5  rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none select-none focus-visible:ring focus-visible:ring-blue-300">
                                {button.text}
                            </ButtonSkelet>)


                    }

                })}

            </div>
        );
    }
}

DialogButton.propTypes = {};

export default DialogButton;